module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/construction-e2430323a0cf62a9c3510b3833ea7134.png";